import type { Achievement } from "../achievement.types";

// Awarded from the atlas's `seen` count after a game she learned from, not
// from a single report: see ../atlasAchievements.ts (spec 2026-10-20 §3.4).
export const firstLightAchievement: Achievement = {
  id: "firstLight",
  name: "First Light",
  description: "Mapped a hundred of her words.",
  icon: "weather-sunset-up",
  check: () => false,
};
